import {
  Checkbox,
  DefaultButton,
  PrimaryButton,
  TextField,
  ChoiceGroup,
  Dropdown,
} from "@fluentui/react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { t } from "i18next";
import MobileInput from "../../../../components/MobileInput";
import UserDetails from "../../components/UserDetails";
import ContactDetails from "../../components/ContactDetails";
import UserProfileDetails from "../../components/UserProfileDetails";
import { USERTYPES } from "../../../../constants/Constants";
import { assignmentConfirmationOptions, userAccountOptions } from "../../helpers/CheckboxOptions";
import { choiceGroupStyles } from "../../helpers/Styles";
import { ACTIONS } from "../../../../constants/Constants";
import { activeStatusOptions } from "../../helpers/CheckboxOptions";
import { radiologistTimeSpentOptions } from "../../helpers/CheckboxOptions";
import { radiologistTypeOptions } from "../../helpers/CheckboxOptions";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { forEach } from "underscore";
import userContext from "../../../../context/users/UserContext";
import "../../helpers/InputFileContainerCSS.css";

const dropDownStyle = {
  dropdown: {
    width: "100%",
  },
  dropdownItemSelected: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
  dropdownItem: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
};

const SettingSection = (props) => {
  const [radiologistSignatureImage, setRadiologistSignatureImage] = useState(props.radiologistSignatureImage ? true : false);
  const [qcSupervisor, setQcSupervisor] = useState(props.values.qcSupervisor);
  const { roles, authenticated, loadByUsername, userId, twoFAGlobalEnable } =
    useContext(userContext);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const setActive = useCallback((e, option) => {
    props.values.active = option.key === "true" ? true : false;
  });

  const setLocked = useCallback((e, option) => {
    props.values.accountNonLocked = option.key === "true" ? true : false;
  });

  const setShowAssignmentConfirmation = useCallback((e, option) => {
    props.values.showConfirmation = option.key === "true" ? true : false;
  });

  const setShowRadiologistTime = useCallback((e, option) => {
    props.values.showRadiologistTime = option.key === "true" ? true : false;
  });

  let modalityList = [];
  props.modalityList.map((modality) => {
    modalityList.push({
      key: modality.id,
      text: modality.name,
    });
  });

  const setRadiologistType = useCallback((e, option) => {
    props.values.radiologistType = option.key;
    if (props.values.radiologistType === 2) {
      props.setExpertRadiologist(true);
      props.values.signatureText = "";
      props.values.signatureImage = null;
    } else {
      props.setExpertRadiologist(false);
    }
  });

  const getTextValue = (key, array) => {
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        return array[i].text;
      }
    }
  };

  const allowedFileTypes = [
    ".JPEG",
    ".jpeg",
    ".PNG",
    ".png",
    ".JPG",
    ".jpg"
  ];


  return (
    <>
      <div className="tab-section">
        {!isMobile && (
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("user.settings")}
            </p>
          </section>
        )}
        <div className="ms-Grid" dir="ltr">
          {(props.state.action === ACTIONS.ADD ||
            props.state.action === ACTIONS.EDIT) && (
            <>
              {/* ACTIVE STATUS OPTION TO BE SHOWN ONLY WHEN LOGGED IN USER IS NOT UPDATING ITSELF  */}
              {(props.state.action === ACTIONS.EDIT || (props.state.action === ACTIONS.ADD && props.userType === USERTYPES.TYPIST )) &&
                userId != props.values.id && (
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.action")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.active ? "true" : "false"
                          }
                          options={activeStatusOptions}
                          styles={choiceGroupStyles}
                          onChange={setActive}
                        />
                      </div>
                    </div>
                  </div>
                )}

            {(!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin')) 
              && (!(roles[0]  === USERTYPES.FIRMADMIN 
              && props.userType === USERTYPES.RADIOLOGIST
              && props.values.countOfconnections > 1)) && (
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.locked-status")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.accountNonLocked ? "true" : "false"
                          }
                          options={userAccountOptions}
                          styles={choiceGroupStyles}
                          onChange={setLocked}
                        />
                      </div>
                    </div>
                  </div>
                )}

              {twoFAGlobalEnable && (!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin')) &&
                !(roles[0]  === USERTYPES.FIRMADMIN && props.userType === USERTYPES.RADIOLOGIST) && (
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.two-factor")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.twoFactorEnabled}
                          value={props.values.twoFactorEnabled}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.twoFactorEnabled =
                              !props.values.twoFactorEnabled;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              
              {((props.state.action === ACTIONS.EDIT || props.state.action === ACTIONS.ADD) && props.userType === USERTYPES.TYPIST ) &&
                userId != props.values.id && (
                 
                    <div
                    className="ms-Grid-row single-line-form-field"
                  
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.enable-ms-word")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showWord}
                          value={props.values.showWord}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.showWord =
                              !props.values.showWord;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  
                )}

              {/* SHOW ASSIGNMENT CONFIRMATION OPTION TO BE SHOWN ONLY WHEN USER TYPE IS ADMIN/FIRMADMIN/SUPERVISOR  */}
              {(props.userType === USERTYPES.ADMIN ||
                props.userType === USERTYPES.FIRMADMIN ||
                props.userType === USERTYPES.SUPERVISOR) && (
                  <>
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key">
                      {t("user.show-assignment-confirmation")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <ChoiceGroup
                        defaultSelectedKey={
                          props.values.showConfirmation ? "true" : "false"
                        }
                        options={assignmentConfirmationOptions}
                        styles={choiceGroupStyles}
                        onChange={setShowAssignmentConfirmation}
                      />
                    </div>
                  </div>
                </div>
                

                <div className="ms-Grid-row single-line-form-field">
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key">
                      {t("user.enable-ms-word")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <Checkbox
                        defaultChecked={props.values.showWord}
                        value={props.values.showWord}
                        styles={choiceGroupStyles}
                        onChange={() => {
                          props.values.showWord =
                            !props.values.showWord;
                        }}
                      />
                    </div>
                  </div>
                </div> 
                {process.env.REACT_APP_VDC_PLATFORM=="true" && <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("heading.peer-review")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.isPeerReviewAdmin
                              ? "Team Member"
                              : props.values.isPeerReviewEvaluator
                              ? "Evaluator"
                              : "None"
                          }
                          options={[
                            {
                              key: "Team Member",
                              text: t("peer-review.peer-review-admin"),
                            },
                            {
                              key: "Evaluator",
                              text: t("peer-review.evaluator"),
                            },
                            { key: "None", text:"None" },

                          ]}
                          styles={choiceGroupStyles}
                          onChange={(event, option) => {
                            if (option.key === "Team Member") {
                              props.values.isPeerReviewAdmin = true;
                              props.values.isPeerReviewEvaluator = false;
                            } else if (option.key === "Evaluator") {
                              props.values.isPeerReviewAdmin = false;
                              props.values.isPeerReviewEvaluator = true;
                            } else if (option.key === "None") {
                              props.values.isPeerReviewAdmin = false;
                              props.values.isPeerReviewEvaluator = false;
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>}

                </>
              )}
               {
               (roles[0]  === USERTYPES.ADMIN && props.userType === USERTYPES.FIRMADMIN) &&
               (
                <>
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >

                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.password-reset-allowed")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        {console.log("Is password reset allowed",props.values.isPasswordResetAllowed)}
                                                {console.log("Is password reset allowed values",props.values)}

                        <Checkbox
                          defaultChecked={props.values.isPasswordResetAllowed}
                          value={props.values.isPasswordResetAllowed}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.isPasswordResetAllowed =
                              !props.values.isPasswordResetAllowed;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
			  
              {/* SHOW RADIOLOGIST TIME SPENT TO BE SHOWN ONLY IN CASE OF SUPERVISOR USER TYPE */}
              {props.userType === USERTYPES.SUPERVISOR && (
                <>
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.qc-supervisor")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.qcSupervisor}
                          value={props.values.qcSupervisor}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.qcSupervisor =
                              !props.values.qcSupervisor;
                            setQcSupervisor(props.values.qcSupervisor);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {!!qcSupervisor && (
                    <>
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.enable-adding-annotations")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.keyImage}
                            value={props.values.keyImage}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.keyImage = !props.values.keyImage;
                            }}
                          />
                        </div>
                      </div>
                    </div>

                      <div
                      className="ms-Grid-row single-line-form-field"
                      >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.enable-save-report")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.qcSaveReport}
                            value={props.values.qcSaveReport}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.qcSaveReport = !props.values.qcSaveReport;
                            }}
                          />
                        </div>
                      </div>
                      </div>
                    </>
                  )}

                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.view-radiologist-time-spent")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.showRadiologistTime ? "true" : "false"
                          }
                          options={radiologistTimeSpentOptions}
                          styles={choiceGroupStyles}
                          onChange={setShowRadiologistTime}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {props.userType === USERTYPES.RADIOLOGIST && (
                <>
                  {/* //Radiologst Type */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6 ">
                      <p className="single-line-form-field-key">
                        {t("user.radiologist-type")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={props.values.radiologistType}
                          options={radiologistTypeOptions}
                          styles={choiceGroupStyles}
                          onChange={setRadiologistType}
                        />
                      </div>
                    </div>
                  </div>
                  {/* //End of radiologist type */}

                  {/* send study assign mail */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.send-study-assign-mail")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.sendAssignMail}
                          value={props.values.sendAssignMail}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.sendAssignMail =
                              !props.values.sendAssignMail;
                          }}
                        />
                      </div>
                    </div>
                  </div>
    {/* for admin */}

 <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.enable-llm-report")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.enableLlmReport}
                          value={props.values.enableLlmReport}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.enableLlmReport =
                              !props.values.enableLlmReport;
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* end of send study assign mail */}

                  {roles[0] === USERTYPES.FIRMADMIN && (
                    <>
                      {/* //Show all studies */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-all-studies")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.showAllStudies}
                              value={props.values.showAllStudies}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.showAllStudies =
                                  !props.values.showAllStudies;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* //End of show all studies */}

                      {/* //Disable submit */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.disable-submit")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.disableSubmit}
                              value={props.values.disableSubmit}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.disableSubmit =
                                  !props.values.disableSubmit;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* //End of disable submit */}

                      {/* on payroll */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.on-payroll")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.onPayroll}
                              value={props.values.onPayroll}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.onPayroll =
                                  !props.values.onPayroll;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of on payroll */}

                      {/* upload study */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.upload-study")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.uploadStudy}
                              value={props.values.uploadStudy}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.uploadStudy =
                                  !props.values.uploadStudy;
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* end of upload study */}

                      {/* QC Radiologist */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.qc-radiologist")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.qcRadiologist}
                              value={props.values.qcRadiologist}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.qcRadiologist =
                                  !props.values.qcRadiologist;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of QC Radiologist */}

                    

                      {/* typist workflow */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.enable-typist-workflow")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.enableTypistWorkflow}
                              value={props.values.enableTypistWorkflow}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.enableTypistWorkflow =
                                  !props.values.enableTypistWorkflow;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of typist workflow */}
                    </>
                  )}

                  {/* Radiologist Capacity */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.radiologist-capacity")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <TextField
                          name="capacity"
                          placeholder={t("user.radiologist-capacity")}
                          type="number"
                          min={1}
                          onChange={props.handleChange}
                          value={props.values.capacity}
                          onBlur={props.handleBlur}
                          errorMessage={props.errors.capacity}
                        />
                      </div>
                    </div>
                  </div>
                  {/* end of Radiologist Capacity */}

                  {/* Check capaciity on self assignment */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.check-capacity-on-self-assignment")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.checkCapacityOnManualAssign}
                            value={props.values.checkCapacityOnManualAssign}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.checkCapacityOnManualAssign =
                                !props.values.checkCapacityOnManualAssign;
                            }}
                          />
                        </div>
                      </div>
                    </div>)}
                  {/* end of  Check capaciity on self assignment */}


                  {/* enable MS Word */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                    className="ms-Grid-row single-line-form-field"
                  
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.enable-ms-word")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showWord}
                          value={props.values.showWord}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.showWord =
                              !props.values.showWord;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  )}
                  
                      {/* end of enable MS word */}

                  {/* first Modality Preference one */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.first-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder={t("user.first-modality-preference")}
                          defaultSelectedKey={props.values.firstModalityPreference}
                          options={modalityList}
                          onChange={(e, selection) => {
                            props.values.firstModalityPreference = selection.key;
                          }}
                          errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* end of First Modality preference */}

                  {/* Second Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.second-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder={t("user.second-modality-preference")}
                          defaultSelectedKey={props.values.secondModalityPreference}
                          options={modalityList}
                          onChange={(e, selection) => {
                            props.values.secondModalityPreference = selection.key;
                          }}
                          errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* end of Second Modality Preference */}

                  {/* Third Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.third-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder={t("user.third-modality-preference")}
                          defaultSelectedKey={props.values.thirdModalityPreference}
                          options={modalityList}
                          onChange={(e, selection) => {
                            props.values.thirdModalityPreference = selection.key;
                          }}
                          errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* end of Third Modality Preference */}

                  {!props.expertRadiologist && (
                    <>
                      {/* signatue text */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.signature-text")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                          <div>
                            <TextField
                              multiline
                              rows={3}
                              name="signatureText"
                              placeholder={t("user.signature-text")}
                              onChange={props.handleChange}
                              value={props.values.signatureText}
                              onBlur={props.handleBlur}
                              errorMessage={
                                props.touched.signatureText && props.errors.signatureText
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of signature text */}

                      {/* signature image */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.signature-image")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            
                            {(props.state.action === ACTIONS.EDIT &&
                              props.radiologistSignatureImage != null && props.radiologistSignatureImage != "" && radiologistSignatureImage && props.values.signatureDto.isSignatureImageDeleted == 0) ? (
                                <div>
                              <img
                                style={{
                                  height: "90px",
                                  width: "150px",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                }}
                                src={props.radiologistSignatureImage}
                                  />
                                  </div>
                            ) : (
                              <div></div>
                            )}
                            <div>
                            <input
                            style={{ width: "112px", overflow: "hidden" }}
                              type="file"
                              id="signatureFile"
                              onChange={(event) => {
                                props.values.signatureImage =
                                  event.target.files;
                                props.setRadiologistImageFileName(event.target.files[0].name);
                                props.values.signatureDto.isSignatureImageDeleted = 0;
                                props.setIsRadiologistSignatureImageDeleted(false);
                                // setRadiologistSignatureImage(true)
                                
                               
                              }}
                              className="file-input-container"
                              accept={allowedFileTypes.join(",")}
                            />
                               <label style={{ marginLeft: "10px" }} for="signatureFile">
                        {props.radiologistImageFileName}
                    </label>
                              {
                                ((props.radiologistSignatureImage != null && props.radiologistSignatureImage != "") || (props.radiologistImageFileName != null && props.radiologistImageFileName != "" && props.radiologistImageFileName != "No File Chosen")) && props.values.signatureDto.isSignatureImageDeleted == 0  && (
                                  <PrimaryButton
                      text="Clear Signature Image"
                                    className="study-list-clear-all-button"
                                    style={{ marginLeft: "5px", marginTop: "5px"}} 
                      onClick={() => {
                        props.handleClearRadiologistSignatureImage()
                        setRadiologistSignatureImage(false);
                        document.getElementById('signatureFile').value = '';
                      }
                    }
                    />)}
                            
                              </div>
                            <p
                              style={{
                                fontSize: "12px",
                                fontStyle: "italic",
                              }}
                            >
                              {t("user.signature-image-size-msg")}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* end of signature image */}
                    </>
                  )}
                </>
              )}
            </>
          )}
          {props.state.action === ACTIONS.VIEW && (
            <>
              {/* ACTIVE STATUS OPTION TO BE SHOWN ONLY WHEN LOGGED IN USER IS NOT UPDATING ITSELF  */}
              {userId != props.values.id && (
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.action")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.active ? "Active" : "Inactive"}</div>
                  </div>
                </div>
              )}

              {(!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin')) 
              && (!(roles[0]  === USERTYPES.FIRMADMIN 
              && props.userType === USERTYPES.RADIOLOGIST
              && props.values.countOfconnections > 1)) && (
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.locked-status")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.accountNonLocked ? "Active" : "Locked"}</div>
                  </div>
                </div>
              )}

              {twoFAGlobalEnable && (!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin'))  &&
                !(roles[0]  === USERTYPES.FIRMADMIN && props.userType === USERTYPES.RADIOLOGIST) && (
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.two-factor")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.twoFactorEnabled ? "Enabled" : "Disabled"}</div>
                  </div>
                </div>)}

              {/* SHOW ASSIGNMENT CONFIRMATION OPTION TO BE SHOWN ONLY WHEN USER TYPE IS ADMIN/FIRMADMIN/SUPERVISOR  */}
              {(props.userType === USERTYPES.ADMIN ||
                props.userType === USERTYPES.FIRMADMIN ||
                props.userType === USERTYPES.SUPERVISOR) && (
                  <>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.show-assignment-confirmation")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showConfirmation ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.enable-ms-word")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showWord ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    {process.env.REACT_APP_VDC_PLATFORM=="true" && 
                      <>
                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("peer-review.peer-review-team-member")}

                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isPeerReviewAdmin ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("peer-review.peer-review-evaluator")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isPeerReviewEvaluator ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    </>}
                  </>
                )}
               {roles[0]  === USERTYPES.ADMIN && props.userType === USERTYPES.FIRMADMIN &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.password-reset-allowed")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isPasswordResetAllowed ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    }
              {/* ENABLE MS WORD OPTION TO BE SHOWN ONLY WHEN USER IS TYPIST/RADIOLOGIST */}
                  {(props.userType === USERTYPES.TYPIST) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.enable-ms-word")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showWord ? "Yes" : "No"}</div>
                      </div>
                    </div>)}

                  {/* end of enable MS Word */}

              {/* SHOW RADIOLOGIST TIME SPENT TO BE SHOWN ONLY IN CASE OF SUPERVISOR USER TYPE */}
              {props.userType === USERTYPES.SUPERVISOR && (
                <>
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.qc-supervisor")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.qcSupervisor ? "Yes" : "No"}</div>
                    </div>
                  </div>

                  {!!qcSupervisor && (
                      <>
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-adding-annotations")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.keyImage ? "Yes" : "No"}</div>
                        </div>
                      </div>

                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-save-report")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.qcSaveReport ? "Yes" : "No"}</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.view-radiologist-time-spent")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        {props.values.showRadiologistTime ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {props.userType === USERTYPES.RADIOLOGIST && (
                <>
                  {/* //Radiologst Type */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6 ">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.radiologist-type")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(
                          props.values.radiologistType,
                          radiologistTypeOptions
                        )}
                      </div>
                    </div>
                  </div>
                  {/* //End of radiologist type */}

                  {/* send study assign mail */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.send-study-assign-mail")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.sendAssignMail ? "Yes" : "No"}</div>
                    </div>
                  </div>

                 <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.enable-llm-report")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.enableLlmReport ? "Yes" : "No"}</div>
                    </div>
                  </div>

                  {/* end of send study assign mail */}

                  {roles[0] === USERTYPES.FIRMADMIN && (
                    <>
                      {/* //Show all studies */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.show-all-studies")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            {props.values.showAllStudies ? "Yes" : "No"}
                          </div>
                        </div>
                      </div>
                      {/* //End of show all studies */}

                      {/* //Disable Submit */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.disable-submit")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            {props.values.disableSubmit ? "Yes" : "No"}
                          </div>
                        </div>
                      </div>
                      {/* //End of disable submit */}

                      {/* on payroll */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.on-payroll")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.onPayroll ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      {/* end of on payroll */}

                      {/* upload study */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.upload-study")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.uploadStudy ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      {/* end of upload study */}

                      {/* QC Radiologist */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.qc-radiologist")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.qcRadiologist ? "Yes" : "No"}</div>
                        </div>
                      </div>

                      
                      {/* end of QC Radiologist */}

                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-typist-workflow")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.enableTypistWorkflow ? "Yes" : "No"}</div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Radiologist Capacity */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.radiologist-capacity")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>{props.values.capacity}</div>
                    </div>
                  </div>
                  {/* end of Radiologist Capacity */}

                  {/* check capacity on self assignment */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.check-capacity-on-self-assignment")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.checkCapacityOnManualAssign ? "Yes" : "No"}</div>
                      </div>
                    </div>)}

                  {/* end of check capacity on self assignment */}


                  {/* enable MS Word */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.enable-ms-word")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showWord ? "Yes" : "No"}</div>
                      </div>
                    </div>)}

                  {/* end of enable MS Word */}

                  {/* first Modality Preference one */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">{t("user.first-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(props.values.firstModalityPreference,modalityList)}
                      </div>
                    </div>
                  </div> */}
                  {/* end of First Modality preference */}

                  {/* Second Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">{t("user.second-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(props.values.secondModalityPreference,modalityList)}
                      </div>
                    </div>
                  </div> */}
                  {/* end of Second Modality Preference */}

                  {/* Third Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">{t("user.third-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(props.values.thirdModalityPreference,modalityList)}
                      </div>
                    </div>
                  </div> */}
                  {/* end of Third Modality Preference */}

                  {!props.expertRadiologist && (
                    <>
                      {/* signatue text */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.signature-text")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                          <div>{props.values.signatureText}</div>
                        </div>
                      </div>
                      {/* end of signature text */}

                      {/* signature image */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.signature-image")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {props.radiologistSignatureImage != "" ? (
                              <img
                                style={{
                                  height: "90px",
                                  width: "150px",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                }}
                                src={props.radiologistSignatureImage}
                              />
                            ) : (
                              <div>{t("user.no-image-found")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* end of signature image */}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SettingSection;
